import PhotoComponent from './photo';

export default class GalleryComponent {
  static CLASSES = {
    GALLERY: 'gallery',
    PHOTO: 'gallery__photo',
    PREVIEWS: 'gallery__previews',
    PREVIEW: 'gallery__preview',
    PREVIEW_ACTIVE: 'gallery__preview--active',
    BUTTON_PREV: 'gallery__button-prev',
    BUTTON_NEXT: 'gallery__button-next'
  };

  static init($gallery) {
    if (!$gallery || $gallery.galleryComponent) {
      return;
    }

    $gallery.galleryComponent = new GalleryComponent($gallery);
  }

  static initAll() {
    document.querySelectorAll(`.${GalleryComponent.CLASSES.GALLERY}`).forEach(($gallery) => {
      GalleryComponent.init($gallery);
    });
  }

  constructor($gallery) {
    this.$gallery = $gallery;
    this.$photo = $gallery.querySelector(`.${GalleryComponent.CLASSES.PHOTO}`);
    this.$previews = $gallery.querySelector(`.${GalleryComponent.CLASSES.PREVIEWS}`);
    this.$$preview = $gallery.querySelectorAll(`.${GalleryComponent.CLASSES.PREVIEW}`);
    this.$buttonPrev = $gallery.querySelector(`.${GalleryComponent.CLASSES.BUTTON_PREV}`);
    this.$buttonNext = $gallery.querySelector(`.${GalleryComponent.CLASSES.BUTTON_NEXT}`);
    this.index = undefined;

    this.onClickPreviews = this.onClickPreviews.bind(this);

    this.init();
  }

  init() {
    PhotoComponent.init(this.$photo);
    this.$previews.addEventListener('click', this.onClickPreviews);
    this.$buttonPrev.addEventListener('click', () => this.selectPhoto(this.index - 1));
    this.$buttonNext.addEventListener('click', () => this.selectPhoto(this.index + 1));
    this.selectPhoto(0);

    if (this.$$preview.length <= 1) {
      this.$buttonPrev.style.display = 'none';
      this.$buttonNext.style.display = 'none';
    }
  }

  destroy() {
    this.$previews.removeEventListener('click', this.onClickPreviews);
    this.$gallery.galleryComponent = null;
  }

  onClickPreviews(event) {
    let $target = event.target;

    while ($target !== event.currentTarget) {
      if ($target.classList.contains(GalleryComponent.CLASSES.PREVIEW)) {
        this.selectPhoto(Array.from(this.$$preview).indexOf($target));
        break;
      }

      $target = $target.parentElement;
    }
  }

  selectPhoto(index) {
    index = ((index % this.$$preview.length) + this.$$preview.length) % this.$$preview.length;

    if (index === this.index) {
      return;
    }

    let $preview = this.$$preview[index];
    let popupOptions = JSON.parse(this.$photo.dataset.popupOptions || '{}');
    let photo = Object.assign({}, popupOptions.items[index]);
    photo.popupOptions = popupOptions;

    popupOptions.activeIndex = index;

    this.$photo.photoComponent.update(photo);

    if (this.index !== undefined) {
      this.$$preview[this.index].classList.remove(GalleryComponent.CLASSES.PREVIEW_ACTIVE);
    }
    $preview.classList.add(GalleryComponent.CLASSES.PREVIEW_ACTIVE);

    this.index = index;
  }
}
